import React from 'react';
import { motion } from 'framer-motion';

const CategoryFilter = ({ categories, selectedCategory, onCategoryChange }) => {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      <button
        onClick={() => onCategoryChange('tutte')}
        className={`px-4 py-2 rounded-full font-medium transition-colors ${
          selectedCategory === 'tutte'
            ? 'bg-[#5C715E] text-white'
            : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
        }`}
      >
        Tutte
      </button>
      {categories.map((category) => (
        <motion.button
          key={category}
          onClick={() => onCategoryChange(category)}
          whileTap={{ scale: 0.95 }}
          className={`px-4 py-2 rounded-full font-medium transition-colors ${
            selectedCategory === category
              ? 'bg-[#5C715E] text-white'
              : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
          }`}
        >
          {category}
        </motion.button>
      ))}
    </div>
  );
};

export default CategoryFilter;